import React, { useState, useRef, useEffect } from "react";
import EmbedBackgroundUploader from "components/Reusable/EmbedPageBackgroundUploader/EmbedBackgroundUploader.js";
import EmbedLimitOptionsModal from "components/Reusable/JUMBOform/Modals/EmbedLimitOptionsModal.js";
import Icon from "components/Elements/Icon/Icon.tsx";
import apiRequest from "utils/ApiRequest/apiRequest";
import JImage from "components/Elements/Image/Image.tsx";
import { useModal } from "contexts/modalContext/modalContext.js";
import { useContent } from "contexts/contentContext/contentContext.js";
import { useUser } from "contexts/userContext/userContext.js";
import { jumbomailImagesSizeLimit } from "utils/jumbomailSettings";
import config from "config";

const uploadImage = `${config.api.resource}/assets/images/personal/upload-image-button.svg`;

const fileReader = new FileReader();

const Branding = ({
  backgroundImagesList,
  setBackgroundImagesList,
  FullDetailsEmbedPage,
  singleOrRotate,
  isDefaultBackgrounds,
}) => {
  const { getTextByKey } = useContent();
  const { isSubscribed } = useUser();
  const { setModal } = useModal();
  //setBackgroundImagesList
  const inputImageRef = useRef();
  const [picture, setPicture] = useState(null);
  const [pictureToReplace, setPictureToReplace] = useState(null);
  const [imageOrderToReplace, setImageOrderToReplace] = useState(0);
  const [showUploadButton, setShowUploadButton] = useState(false);
  const [imageLogoName, setImageLogoName] = useState("");
  const [errorsInput, setErrorsInput] = useState(null);

  useEffect(() => {
    if (singleOrRotate === "Single") {
      if (backgroundImagesList.length === 0) {
        setShowUploadButton(true);
      } else {
        setShowUploadButton(false);
      }
    } else {
      if (backgroundImagesList.length < 5) {
        setShowUploadButton(true);
      } else if (isDefaultBackgrounds) {
        setShowUploadButton(true);
      } else {
        setShowUploadButton(false);
      }
    }
  }, [singleOrRotate, backgroundImagesList, isDefaultBackgrounds]);

  useEffect(() => {
    if (picture) {
      let newPicture = {
        ImageSrc: picture,
        ImageOrder: backgroundImagesList.length + 1,
      };
      setBackgroundImagesList((prev) => [...prev, newPicture]);
      setPicture(null);
    }
  }, [picture]);

  useEffect(() => {
    if (imageOrderToReplace > 0) {
      if (pictureToReplace) {
        let newPicture = {
          ImageSrc: pictureToReplace,
          ImageOrder: imageOrderToReplace,
        };
        let newArray = backgroundImagesList.map((item) => {
          if (item.ImageOrder === imageOrderToReplace) {
            return newPicture;
          }
          return item;
        });
        setBackgroundImagesList(newArray);
      }
    }
  }, [imageOrderToReplace, pictureToReplace]);

  const deleteImage = async (image) => {
    if (!isSubscribed()) {
      setModal(() => <EmbedLimitOptionsModal />);
    } else {
      const body = {
        DeleteEmbedPageImagePageId:
          FullDetailsEmbedPage &&
          FullDetailsEmbedPage.EmbedDynamicPage.EmbedPageId,
        DeleteEmbedPageImageOrder: image.ImageOrder,
      };
      const response = await apiRequest(
        "EmbedDynamics",
        "DeleteEmbedPageImageReact",
        body,
        "POST"
      );
      if (response.status === "success") {
        if (response.data === 0) {
          setBackgroundImagesList((prev) =>
            prev.filter((item) => item.ImageSrc !== image.ImageSrc)
          );
        } else {
        }
      } else {
        console.log("error res", response);
      }
    }
  };
  const uploadOnOldImage = (image) => {
    if (!isSubscribed()) {
      setModal(() => <EmbedLimitOptionsModal />);
    } else {
      setModal(() => (
        <EmbedBackgroundUploader
          needReplace={true}
          setBackgroundImage={setPictureToReplace}
          backgroundImage={image.ImageSrc}
          imagesList={backgroundImagesList}
          setImagesList={setBackgroundImagesList}
          imageOrder={image.ImageOrder}
          setImageOrderToReplace={setImageOrderToReplace}
        />
      ));
    }
  };

  const handleNewImage = (e) => {
    if (!isSubscribed()) {
      setModal(() => <EmbedLimitOptionsModal />);
    } else {
      if (e.target.files[0]) {
        setErrorsInput(null);
        const allowedExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "webp"];
        const fileExtension = e.target.files[0].name
          .split(".")
          .pop()
          .toLowerCase();
        const fileSize = e.target.files[0].size;
        const validSize = jumbomailImagesSizeLimit["embedPageBackground"];
        const allowedSize = validSize >= fileSize;
        const isAllowedExtension = allowedExtensions.includes(fileExtension);
        if (isAllowedExtension && allowedSize) {
        } else {
          setErrorsInput(
            !isAllowedExtension
              ? getTextByKey("file-type-not-supported")
              : getTextByKey("embed-logo-validation-size-text")
          );
        }
        fileReader.readAsDataURL(e.target.files[0]);
        const logoName = e.target.files[0].name.replaceAll("&", "-");
        setImageLogoName(logoName);
      }
    }
  };

  fileReader.onload = function (event) {
    var image = new Image();
    image.onload = function () {
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");
      //const ratio = 1;
      const ratio = image.width > 2000 ? image.width / 2000 : 1;

      canvas.width = image.width / ratio;
      canvas.height = image.height / ratio;
      context.drawImage(
        image,
        0,
        0,
        image.width,
        image.height,
        0,
        0,
        canvas.width,
        canvas.height
      );
      setModal(() => (
        <EmbedBackgroundUploader
          needReplace={false}
          errorsInput={errorsInput}
          setErrorsInput={setErrorsInput}
          backgroundName={imageLogoName}
          pcImage={true}
          setBackgroundImage={setPicture}
          backgroundImage={canvas.toDataURL()}
          imagesList={backgroundImagesList}
          setImagesList={setBackgroundImagesList}
          imageOrder={0}
          setImageOrderToReplace={setImageOrderToReplace}
        />
      ));
    };
    image.src = event.target.result;
  };

  const openLimitModal = () => {
    if (!isSubscribed()) {
      setModal(() => <EmbedLimitOptionsModal />);
    }
  };

  return (
    <div className="body">
      <div className="text-info">
        <span className="text design-text">
          {getTextByKey("background-image-title-personal-page")}
        </span>
      </div>
      <div className="branding-images">
        <div className="upload-list-images">
          {backgroundImagesList.map((item, i) =>
            singleOrRotate.toLowerCase() === "random" ? (
              <div key={i} className="image-div">
                <div className="image" key={i}>
                  <div className="hover-div">
                    <div
                      className="delete-div"
                      onClick={() => deleteImage(item)}
                    >
                      <Icon name="trash-solid" />
                    </div>
                    <div
                      className="upload"
                      onClick={() => uploadOnOldImage(item)}
                    >
                      <Icon src={uploadImage} />
                      <span>
                        {getTextByKey("personal-pages-upload-image-button")}
                      </span>
                    </div>
                  </div>

                  <JImage src={item.ImageSrc} alt="" />
                </div>
              </div>
            ) : i === 0 ? (
              <div key={i} className="image-div">
                <div className="image" key={i}>
                  <div className="hover-div">
                    <div
                      className="delete-div"
                      onClick={() => deleteImage(item)}
                    >
                      <Icon name="trash-solid" />
                    </div>
                    <div
                      className="upload"
                      onClick={() => uploadOnOldImage(item)}
                    >
                      <Icon src={uploadImage} />
                      <span>
                        {getTextByKey("personal-pages-upload-image-button")}
                      </span>
                    </div>
                  </div>

                  <JImage src={item.ImageSrc} alt="" />
                </div>
              </div>
            ) : null
          )}
        </div>
        {showUploadButton && (
          <div className={`upload-div ${!isSubscribed() ? "disable" : ""}`}>
            <input
              disabled={!isSubscribed()}
              accept="image/*"
              className="input-image-class"
              name="newImage"
              type="file"
              onChange={handleNewImage}
              ref={inputImageRef}
            ></input>
            <div className="upload" onClick={() => openLimitModal()}>
              <Icon src={uploadImage} />
              <span>{getTextByKey("personal-pages-upload-image-button")}</span>
            </div>
            {/* <div className="images-input-div"></div> */}
          </div>
        )}
      </div>
    </div>
  );
};

export default Branding;
